var {
  useControlledState
} = require("@react-stately/utils");

/**
 * Manages state for an overlay trigger. Tracks whether the overlay is open, and provides
 * methods to toggle this state.
 */
function useOverlayTriggerState(props) {
  let [isOpen, setOpen] = useControlledState(props.isOpen, props.defaultOpen || false, props.onOpenChange);
  return {
    isOpen,

    open() {
      setOpen(true);
    },

    close() {
      setOpen(false);
    },

    toggle() {
      setOpen(!isOpen);
    }

  };
}

exports.useOverlayTriggerState = useOverlayTriggerState;
